const nonEmptyValidator = (value: string) => value === '' ? ['Veld is vereist'] : []

export default nonEmptyValidator
